<template>
<v-main>
  <v-layout row class="pa-6" justify-center>
    <v-card class="px-5 rounded-xl" width="1200">
      <v-card-title>
        Alterar serviços do Médico
      </v-card-title>
      <v-divider />
      <v-text-field v-model="nomeMedico" disabled :type="'text'" name="input-10-1" label="Nome do médico" counter @click:append="show1 = !show1"></v-text-field>
      <v-form v-model="valid" ref="form">
        <v-autocomplete label="Serviços" v-model="servicosEscolhidos" item-value="idServico" item-text="nomeEspecialidade" :rules="[(v) => v && v.length > 0 || 'o médico deve possuir um ou mais serviços']" @input="alterou()" no-data-text="Nenhu serviço encontrado" :items="listaServicosUnidade" required multiple>
        </v-autocomplete>

        <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Você deve concordar para cadastrar!']" required></v-checkbox>
        <v-alert :value="erroEditar" color="error" icon="warning" outlined>
          Erro ao editar nome !!
        </v-alert>

        <v-alert :value="erroId" color="error" icon="warning" outlined>
          Escolha um medico na lista de médicos !!
        </v-alert>
        <v-alert :value="erroServicosIguais" color="error" icon="warning" outlined>
          Serviços já cadastrados para este Médico
        </v-alert>

        <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
          Sucesso ao alterar serviços do médico !!
        </v-alert>

      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn rounded dark @click="cadastrarTecnicoServico" :class="{ red: !valid, green: valid }">Salvar</v-btn>
        <v-btn rounded outlined @click="" to='/listaMedicosUnidade'>
          <v-icon left>keyboard_backspace</v-icon>
          voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>

  <!-- serv Unidade :  {{listaServicosUnidade}} -->
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'
// import EventBus from '../../../main';

export default {
  name: 'editarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      erroEditar: false,
      idMedico: '',
      variavelAlterou: true,
      erroId: false,
      nomeMedico: '',
      erroServicosIguais: false,
      servicosEscolhidos: [],
      sucessoEditar: false,
      servicosInicial: [],
      isEditing: true,
      listaServicos: [],
      listaServicosUnidade: [],
      nomeEspecialidade: '',
      idServicoEscolhido: '',
      valid: false,
      checkbox: false,
      nomeRules: [
        (v) => v && v.length > 5 || 'nome deve ter mais de 5 caracteres'
      ],
      items: [{
        nomeEspecialidade: 'Cardiologia',
        idServico: 1,
        quantVagas: 1,
        idLocal: 1
      },
      {
        nomeEspecialidade: 'Urologia',
        idServico: 3,
        quantVagas: 2,
        idLocal: 2
      },
      {
        nomeEspecialidade: 'Cirugia',
        idServico: 2,
        quantVagas: 10,
        idLocal: 3
      },
      {
        nomeEspecialidade: 'Ultrasom',
        idServico: 4,
        quantVagas: 10,
        idLocal: 4
      },
      {
        nomeEspecialidade: 'Cirugia 3',
        idServico: 5,
        quantVagas: 11,
        idLocal: 5
      },
      {
        nomeEspecialidade: 'Cirugia 4',
        idServico: 6,
        quantVagas: 11,
        idLocal: 6
      }
      ]
    }
  },
  mounted () {
    console.log('em mounted cadst. medic servic')
    console.log(this.$route.params.item)
    if (!this.$route.params.item) {
      this.$router.push('/listaMedicosUnidade')
      return
    }

    this.user = this.$store.getters.usuario
    this.idMedico = this.$route.params.item.idMedico
    this.nomeMedico = this.$route.params.item.nome
    this.erroEditar = false
    this.retornarServicosUnidade()
    this.retornarServicosMedico()
    this.sucessoEditar = false
  },
  methods: {

    alterou () {
      this.variavelAlterou = false
    },

    retornarServicosUnidade () {
      console.log('em retornar servico unidade...')
      administradorUnidadeService.administradorUnidade
        .retornarServicosUnidade(this.user.idUnidade)
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          this.listaServicosUnidade = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarServicosMedico () {
      console.log('em retornar servicos tecnico...')
      administradorUnidadeService.administradorUnidade
        .retornarServicosMedico(this.idMedico)
        .then(rsp => {
          console.log('rsp serv medi:', rsp.data)
          this.servicosEscolhidos = rsp.data
          this.servicosInicial = rsp.data
          console.log(this.listaServicos)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    cadastrarTecnicoServico () {
      console.log('em cadastrar MedicoServico')

      if (this.$refs.form.validate()) {
        let servicosAux = []
        let servicosSemNull = []
        this.erroServicosIguais = false
        // nesse caso quer dizer que removeu todos servicos
        if (this.servicosInicial.length > 0 && this.servicosEscolhidos.length == 0) {
          console.log('primeiro if')
          for (let index = 0; index < this.servicosInicial.length; index++) {
            const element = this.servicosInicial[index]
            servicosAux[index] = {
              idServico: element.idServico,
              status: 0
            }
          }
          // console.log(servicosAux);
          // return
        // nesse caso o medico inicialmente não tinha serviços e adicionou servicos ao medico
        } else if (this.servicosInicial.length == 0 && this.servicosEscolhidos.length > 0) {
          console.log('segundo if')
          for (let index = 0; index < this.servicosEscolhidos.length; index++) {
            const element = this.servicosEscolhidos[index]
            servicosAux[index] = {
              idServico: element,
              status: 1
            }
          }
          // console.log(servicosAux);
          // return
        } else {
          let servicosInicial = this.servicosInicial
          // modifica o array
          for (let index = 0; index < this.servicosEscolhidos.length; index++) {
            const element = this.servicosEscolhidos[index]
            servicosAux[index] = {
              idServico: element,
              status: null
            }
          }

          servicosAux.forEach(function (elementEscolhido, indexAux) {
            let estava = false
            let index = 0
            for (let index = 0; index < servicosInicial.length; index++) {
              const element = servicosInicial[index]
              if (element.idServico == elementEscolhido.idServico) {
                estava = true
              }
            }
            if (!estava) {
              servicosAux[indexAux].status = 1
            }
          })

          // console.log(servicosAux);
          // return;
          servicosInicial.forEach(function (elementInicial, indexInicial) {
            let removeu = false
            let idServico = 0
            for (let index = 0; index < servicosAux.length; index++) {
              const element = servicosAux[index]
              if (element.idServico == elementInicial.idServico) {
                removeu = true
                // idServico = element.idServico
              }
            }
            if (!removeu) {
              idServico = elementInicial.idServico
              servicosAux.push({
                idServico: idServico,
                status: 0
              })
            }
          })

          servicosAux.forEach(function (servico, index) {
            if (servico.status == 1) {
              let servicoAux = {
                idServico: servico.idServico,
                status: servico.status
              }
              servicosAux.splice(index, 1)
              servicosAux.unshift(servicoAux)
            }
            if (servico.status == 0) {
              let servicoAux = {
                idServico: servico.idServico,
                status: servico.status
              }
              servicosAux.splice(index, 1)
              servicosAux.push(servicoAux)
            }
          })

          // removendo o null
          for (let i = 0; i < servicosAux.length; i++) {
            if (servicosAux[i].status != null) {
              servicosSemNull.push(servicosAux[i])
              // console.log(diasDaSemanaAux);
            }
          }
          servicosAux = servicosSemNull
          console.log(servicosAux)
        }
        if (servicosAux.length == 0) {
          this.erroServicosIguais = true
        }

        administradorUnidadeService.administradorUnidade
          .cadastraTecnicoServico(this.idMedico, servicosAux).then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }

            if (rsp.data === true || rsp.data === 'true') {
              this.sucessoEditar = true
              setTimeout(() => this.$router.push({
                path: '/listaMedicosUnidade'
              }), 2000)
              // this.clear();
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }

  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
